import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { toast } from '@/hooks/use-toast'

const ROTA_DE_DOCUMENTOS = '/app/documentos'

interface AcessoNegadoProps {
  mensagem: string
}

export function AcessoNegado({ mensagem }: AcessoNegadoProps): null {
  const navigate = useNavigate()
  const jaRedirecionou = useRef(false)

  useEffect(() => {
    if (jaRedirecionou.current) return
    jaRedirecionou.current = true

    toast.erro(mensagem)
    navigate(ROTA_DE_DOCUMENTOS, { replace: true })
  }, [mensagem, navigate])

  return null
}
